export class SessionProposal {
    constructor(
        public id: number,
        public title: string,
        public trainerId: number,
        public trainerName: string,
        public location: string,
        public answerDate: Date,
        public sessionId: number,
        public virtualSessionId: number,
        public days: number,
        public type: string,
        public answer: any
    ) {}
}



// WEBPACK FOOTER //
// ./src/app/_services/session/proposal/proposal.model.ts